import { isTokenExpired, removeToken } from './tokenManager';

export const getToken = () => localStorage.getItem('token');

export const isAuthenticated = () => {
   const token = getToken();
   return token && !isTokenExpired(token);
};

export const getUserId = () => {
   const user = JSON.parse(localStorage.getItem('user'));
   return user ? user.id : null;
};

export const getAdminId = () => {
   const admin = JSON.parse(localStorage.getItem('user'));
   return admin ? admin.id : null;
};

// export const getUserRole = () => {
//    const token = getToken();
//    if (!token) return null;
//    try {
//       const decoded = jwtDecode(token); // Use it as a function
//       return decoded.role;
//    } catch (error) {
//       console.error('Failed to decode token:', error);
//       return null;
//    }
// };

export const getUserRole = () => {
   const token = getToken();
   if (!token) return null;
   try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const payload = JSON.parse(window.atob(base64));
      return payload.role;
   } catch (error) {
      console.error('Failed to decode token:', error);
      return null;
   }
};

export const logout = () => {
   // Clear all auth-related data
   removeToken();
   localStorage.removeItem('user');
   localStorage.removeItem('admin');

   // Reset theme to light mode in auth page
   document.documentElement.classList.remove('dark');
   localStorage.setItem('theme', 'light'); // Set to light instead of removing

   // Redirect to auth page
   console.log('Logging out...');
   window.location.href = '/auth';
};

export const getUserRoles = () => {
   const user = JSON.parse(localStorage.getItem('user'));
   const admin = JSON.parse(localStorage.getItem('admin'));
   const roles = user?.roles || admin?.roles || [];
   return roles;
};

export const initializeUserTheme = async (userData) => {
   if (userData?.themePreference) {
      localStorage.setItem('theme', userData.themePreference);
      if (userData.themePreference === 'dark') {
         document.documentElement.classList.add('dark');
      } else {
         document.documentElement.classList.remove('dark');
      }
   }
};

export const hasRole = (role) => {
   const user = JSON.parse(localStorage.getItem('user'));
   const admin = JSON.parse(localStorage.getItem('admin'));
   const roles = user?.roles || admin?.roles || [];
   return roles.includes(role);
};

export const getAdminDetails = () => {
   const admin = JSON.parse(localStorage.getItem('admin'));
   // console.log('Admin Details:', admin.firstName, admin.lastName);
   return admin || null;
};

export const isTechnicalStaff = () => {
   return hasRole('Technical_Staff');
};

export const getStaffName = () => {
   const admin = JSON.parse(localStorage.getItem('user'));
   return admin ? admin.firstName + ' ' + admin.lastName : null;
};

export const getStaffRole = () => {
   const admin = JSON.parse(localStorage.getItem('user'));
   return admin ? admin.roles : null;
};


